export const hexagrams = {
  0: "Thuần Khôn", 1: "Địa Thiên Thái", 2: "Địa Trạch Lâm", 3: "Địa Hỏa Minh Di",
  4: "Địa Lôi Phục", 5: "Địa Phong Thăng", 6: "Địa Thủy Sư", 7: "Địa Sơn Khiêm",
  8: "Thuần Khôn", 9: "Địa Thiên Thái", 10: "Thiên Địa Bĩ", 11: "Thuần Càn",
  12: "Thiên Trạch Lý", 13: "Thiên Hỏa Đồng Nhân", 14: "Thiên Lôi Vô Vọng",
  15: "Thiên Phong Cấu", 16: "Thiên Thủy Tụng", 17: "Thiên Sơn Độn",
  18: "Thiên Địa Bĩ", 19: "Thuần Càn", 20: "Trạch Địa Tụy", 21: "Trạch Thiên Quải",
  22: "Thuần Đoài", 23: "Trạch Hỏa Cách", 24: "Trạch Lôi Tùy",
  25: "Trạch Phong Đại Quá", 26: "Trạch Thủy Khốn", 27: "Trạch Sơn Hàm",
  28: "Trạch Địa Tụy", 29: "Trạch Thiên Quải", 30: "Hỏa Địa Tấn",
  31: "Hỏa Thiên Đại Hữu", 32: "Hỏa Trạch Khuê", 33: "Thuần Ly",
  34: "Hỏa Lôi Phệ Hạp", 35: "Hỏa Phong Đỉnh", 36: "Hỏa Thủy Vị Tế",
  37: "Hỏa Sơn Lữ", 38: "Hỏa Địa Tấn", 39: "Hỏa Thiên Đại Hữu",
  40: "Lôi Địa Dự", 41: "Lôi Thiên Đại Tráng", 42: "Lôi Trạch Quy Muội",
  43: "Lôi Hỏa Phong", 44: "Thuần Chấn", 45: "Lôi Phong Hằng",
  46: "Lôi Thủy Giải", 47: "Lôi Sơn Tiểu Quá", 48: "Lôi Địa Dự",
  49: "Lôi Thiên Đại Tráng", 50: "Phong Địa Quan", 51: "Phong Thiên Tiểu Súc",
  52: "Phong Trạch Trung Phu", 53: "Phong Hỏa Gia Nhân", 54: "Phong Lôi Ích",
  55: "Thuần Tốn", 56: "Phong Thủy Hoán", 57: "Phong Sơn Tiệm",
  58: "Phong Địa Quan", 59: "Phong Thiên Tiểu Súc", 60: "Thủy Địa Tỷ",
  61: "Thủy Thiên Nhu", 62: "Thủy Trạch Tiết", 63: "Thủy Hỏa Ký Tế",
  64: "Thủy Lôi Truân", 65: "Thủy Phong Tỉnh", 66: "Thuần Khảm",
  67: "Thủy Sơn Kiển", 68: "Thủy Địa Tỷ", 69: "Thủy Thiên Nhu",
  70: "Sơn Địa Bác", 71: "Sơn Thiên Đại Súc", 72: "Sơn Trạch Tổn",
  73: "Sơn Hỏa Bí", 74: "Sơn Lôi Di", 75: "Sơn Phong Cổ",
  76: "Sơn Thủy Mông", 77: "Thuần Cấn", 78: "Sơn Địa Bác",
  79: "Sơn Thiên Đại Súc", 80: "Thuần Khôn", 81: "Địa Thiên Thái",
  82: "Địa Trạch Lâm", 83: "Địa Hỏa Minh Di", 84: "Địa Lôi Phục",
  85: "Địa Phong Thăng", 86: "Địa Thủy Sư", 87: "Địa Sơn Khiêm",
  88: "Thuần Khôn", 89: "Địa Thiên Thái", 90: "Thiên Địa Bĩ",
  91: "Thuần Càn", 92: "Thiên Trạch Lý", 93: "Thiên Hỏa Đồng Nhân",
  94: "Thiên Lôi Vô Vọng", 95: "Thiên Phong Cấu", 96: "Thiên Thủy Tụng",
  97: "Thiên Sơn Độn", 98: "Thiên Địa Bĩ", 99: "Thuần Càn"
};
